import script from "./followup-item.vue?vue&type=script&setup=true&lang=js"
export * from "./followup-item.vue?vue&type=script&setup=true&lang=js"

import "./followup-item.vue?vue&type=style&index=0&id=9c2d0d82&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c2d0d82"]])

export default __exports__